import { render, staticRenderFns } from "./generalCargoWarehouse.vue?vue&type=template&id=236162fa&"
import script from "./generalCargoWarehouse.vue?vue&type=script&lang=js&"
export * from "./generalCargoWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236162fa')) {
      api.createRecord('236162fa', component.options)
    } else {
      api.reload('236162fa', component.options)
    }
    module.hot.accept("./generalCargoWarehouse.vue?vue&type=template&id=236162fa&", function () {
      api.rerender('236162fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/generalCargoWarehouse.vue"
export default component.exports